export const RED = '#E5261F';
export const BLUE = '#00A5CC';
export const GREY = '#F0F0F0;';
export const LIGHT_GREY = '#F8F8F8;';
export const DARK_GREY = '#E7E7E8;';
export const ORANGE = '#FFA63C';
export const GREEN = '#55BD9D';
export const LIGHT_GREEN = '#6dc56b';
export const BLACK = '#140F1F';
export const PURPLE = '#a570dc';

export function rgba_RED(opacity = 1) {
    return rgba(229, 38, 31, opacity);
}

export function rgba_BLUE(opacity = 1) {
    return rgba(0, 165, 204, opacity);
}

export function rgba_GREY(opacity = 1) {
    return rgba(240, 240, 240, opacity);
}

export function rgba_LIGHT_GREY(opacity = 1) {
    return rgba(248, 248, 248, opacity);
}

export function rgba_DARK_GREY(opacity = 1) {
    return rgba(231, 231, 231, opacity);
}

export function rgba_ORANGE(opacity = 1) {
    return rgba(255, 166, 60, opacity);
}

export function rgba_GREEN(opacity = 1) {
    return rgba(85, 189, 157, opacity);
}

export function rgba_BLACK(opacity = 1) {
    return rgba(20, 15, 31, opacity);
}

function rgba(r, g, b, a) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
